(function($) {
    $(function() {
        // Back to Department link
        $("a[target='_blank']").append($('<span class="screen-reader-text">Opens in new window</span>'));
    });
} )( jQuery );